module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加标签")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "标签名",
      "size": "mini"
    },
    model: {
      value: (_vm.params.tag_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "tag_name", $$v)
      },
      expression: "params.tag_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tagsList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tag_id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tag_name",
      "label": "标签名称",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "color": "#ffffff"
          },
          attrs: {
            "color": scope.row.tag_color,
            "size": "mini"
          }
        }, [_vm._v(_vm._s(scope.row.tag_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "标签描述",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.page_size) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.page_size
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑标签",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "预览最终结果"
      }
    }, [_c('el-tag', {
      style: ('color:' + _vm.form.font_color),
      attrs: {
        "color": _vm.form.tag_color,
        "size": "mini"
      }
    }, [_vm._v(_vm._s(_vm.form.tag_name))])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "标签名称",
        "prop": "tag_name",
        "rules": [{
          required: true,
          message: '请输入标签名称',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入标签名称"
      },
      model: {
        value: (_vm.form.tag_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "tag_name", $$v)
        },
        expression: "form.tag_name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "标签说明"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入标签说明"
      },
      model: {
        value: (_vm.form.description),
        callback: function($$v) {
          _vm.$set(_vm.form, "description", $$v)
        },
        expression: "form.description"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "标签颜色"
      }
    }, [_c('el-color-picker', {
      attrs: {
        "show-alpha": "",
        "predefine": _vm.predefineColors
      },
      model: {
        value: (_vm.form.tag_color),
        callback: function($$v) {
          _vm.$set(_vm.form, "tag_color", $$v)
        },
        expression: "form.tag_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "字体颜色"
      }
    }, [_c('el-color-picker', {
      attrs: {
        "show-alpha": "",
        "predefine": _vm.predefineColors
      },
      model: {
        value: (_vm.form.font_color),
        callback: function($$v) {
          _vm.$set(_vm.form, "font_color", $$v)
        },
        expression: "form.font_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "前台显示"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.front_show),
        callback: function($$v) {
          _vm.$set(_vm.form, "front_show", $$v)
        },
        expression: "form.front_show"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0",
        "border": ""
      }
    }, [_vm._v("不显示")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveTagData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e3fe062", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e3fe062"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/distributortags.vue
// module id = 2521
// module chunks = 0